// import { User } from '@mtc/typings/common';
import jwt_decode from 'jwt-decode';

const MILLISECONDS_IN_SECOND = 1000;
const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_DAY = 86400;

const MINUTES_BEFORE_EXP = 5;

export class TokenGroup {

	public accessToken: string;

	public refreshToken: string;

	public idToken: string;

	public decoded: any;

	public orgUuid: string;

	public accessTokenExpirationDateTime: number;

	public refreshTokenExpirationDateTime: number;

	constructor(tokenGroup: any) {
		this.accessToken = tokenGroup.accessToken || tokenGroup.access_token;
		this.refreshToken = tokenGroup.refreshToken || tokenGroup.refresh_token;
		this.idToken = tokenGroup.idToken || tokenGroup.id_token;
		this.decoded = jwt_decode(this.idToken);
		this.orgUuid = tokenGroup.metadata?.orgUuid ?? tokenGroup.orgUuid;
		if (tokenGroup.expiresIn) {
			this.accessTokenExpirationDateTime = new Date().getTime() + tokenGroup.expiresIn * MILLISECONDS_IN_SECOND;
		} else {
			this.accessTokenExpirationDateTime = tokenGroup.accessTokenExpirationDateTime;
		}
		if (tokenGroup.refreshTokenExpiresIn) {
			this.refreshTokenExpirationDateTime = new Date().getTime() + tokenGroup.refreshTokenExpiresIn * MILLISECONDS_IN_SECOND;
		} else {
			this.refreshTokenExpirationDateTime = tokenGroup.refreshTokenExpirationDateTime;
		}
	}

	public isAccessTokenValid(): boolean {
		return this.accessTokenExpirationDateTime >= new Date().getTime();
	}

	public isRefreshTokenValid(): boolean {
		return this.refreshTokenExpirationDateTime >= new Date().getTime();
	}

	public isIdTokenValid(clientId: string): boolean {
		return this.decoded.iss === 'PointClickCare' && this.decoded.aud === clientId &&
			this.decoded.exp >= new Date().getTime() / MILLISECONDS_IN_SECOND;
	}
}
